import React from 'react';
import ContactInfo from '../components/ContactInfo';

const Contact = () => {
  return (
    <main className="flex-grow container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold text-center text-white mb-12">
        Kapcsolat
      </h1>

      <div className="max-w-4xl mx-auto">
        <div className="bg-gray-800 rounded-xl p-8 shadow-lg">
          <h2 className="text-2xl font-semibold text-white mb-6">
            Elérhetőségeink
          </h2>
          
          <div className="space-y-6 text-gray-300">
            <div className="flex items-center space-x-4">
              <svg className="w-6 h-6 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              <div>
                <p className="font-medium">Telefonszám:</p>
                <a href="tel:+36709083086" className="text-purple-400 hover:text-purple-300">
                  +36 70 908 3086
                </a>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <svg className="w-6 h-6 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <div>
                <p className="font-medium">Email cím:</p>
                <a href="mailto:support@webforyou.hu" className="text-purple-400 hover:text-purple-300">
                  support@webforyou.hu
                </a>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <svg className="w-6 h-6 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <div>
                <p className="font-medium">Székhely:</p>
                <p>4400 Nyíregyháza, Tokaji út 37/F</p>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <svg className="w-6 h-6 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <div>
                <p className="font-medium">Adószám:</p>
                <p>29146699-2-15</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Contact; 